import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import EndocrineThyroidCombined from "./index";

const EndocrineThyroidWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={EndocrineThyroidCombined}
    keyControlsId="endocrine-thyroid-key"
    {...props}
  />
);

export default EndocrineThyroidWithToggleKey;
